(function () {
  function activate(root, index) {
    var key = String(index);
    var panels = root.querySelectorAll('[data-split-showcase-panel]');
    var rights = root.querySelectorAll('[data-split-showcase-right]');
    var triggers = root.querySelectorAll('[data-split-showcase-trigger]');

    panels.forEach(function (el) {
      var on = el.getAttribute('data-split-showcase-panel') === key;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-hidden', on ? 'false' : 'true');
    });

    rights.forEach(function (el) {
      var on = el.getAttribute('data-split-showcase-right') === key;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-hidden', on ? 'false' : 'true');
    });

    triggers.forEach(function (btn) {
      var on = btn.getAttribute('data-split-showcase-trigger') === key;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  function init(root) {
    var triggers = root.querySelectorAll('[data-split-showcase-trigger]');
    if (!triggers.length) return;

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-split-showcase-trigger');
        if (idx == null) return;
        activate(root, idx);
      });
    });

    activate(root, '0');
  }

  document.querySelectorAll('[data-split-showcase]').forEach(init);
})();
